import { render, staticRenderFns } from "./modalEliminarProyectos.vue?vue&type=template&id=1352996a"
import script from "./modalEliminarProyectos.vue?vue&type=script&lang=js"
export * from "./modalEliminarProyectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports